/**
 * Converts a string to lowercase
 * 
 * 'AbC' => 'abc'
 */

function lowercase (value) {
  return (value || value === 0)
    ? value.toString().toLowerCase()
    : ''
}

export default lowercase


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-filters/src/string/lowercase.js
// module id = /T8/
// module chunks = 34